export default {
  'PresentationDetail.tab.detail': 'Detail',
  'PresentationDetail.tab.notes': 'Poznámky',
  'PresentationDetail.tab.chat': 'Chat',
  'PresentationNotes.title': 'Poznámky ku prezentácii',
  'PresentationNotes.hint': 'Poznámky sa ukladajú automaticky',
  'PresentationNotes.shareMail': 'Pošli poznámky mailom',
  'ReportProblemPage.submitButton': 'Nahlásiť problém',
  'NewVersionPrompt.message': 'Je dostupný nový obsah',
  'NewVersionPrompt.action': 'NAČÍTAŤ',
  'addons.Feedback.sent': 'Pošli feedback',
  'addons.Feedback.sentOk': 'Ďakujeme za feedback',
  'addons.Feedback.sentError': 'Nepodarilo sa poslať. Skúste znova neskôr.',
  'addons.Chat.loading': 'Chat sa načítava...',
  'addons.Chat.error': 'Chyba pri načítavaní chatu. Skúste znova neskôr.',
  'addons.Chat.offline': 'Chat sa načíta keď budete online.',
}



// WEBPACK FOOTER //
// ./src/intl/messages/sk.js